/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Titlelabel1Inputs */

const he_posts_titlelabel1 = /** @type {(inputs: Posts_Titlelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כותרת`)
};

const en_posts_titlelabel1 = /** @type {(inputs: Posts_Titlelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Posts_Titlelabel1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_titlelabel1 = /** @type {((inputs?: Posts_Titlelabel1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Titlelabel1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_titlelabel1(inputs)
	return en_posts_titlelabel1(inputs)
});
export { posts_titlelabel1 as "posts_titleLabel" }